import { useRef, useState, useEffect } from 'react';

import { crmApi, errMsg } from '@crm/api';
import { UiButton } from '@shared/common/ui/UiButton';
import { QrPaymentModal } from '@crm/components/QrPaymentModal';

function isSubscriptionTariff(tariff) {
  return Number(tariff?.tariffCount) > 1;
}

function computeAmount(price, client, tariff) {
  const p = Number(price) || 0;
  if (!isSubscriptionTariff(tariff)) return p;
  const st = Number(client.saleType);
  const sa = Number(client.saleAmount) || 0;
  if (!sa || (st !== 1 && st !== 2)) return p;
  if (st === 1) return Math.max(0, p - (p / 100) * sa);
  return Math.max(0, p - sa);
}

export function ClientsQuickPayCell({
  branchId,
  client,
  directionId,
  directionName,
  tariffs,
  tariffNameById,
  onPaid,
}) {
  const [open, setOpen] = useState(false);
  const [qrPayment, setQrPayment] = useState(null);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, [open]);

  if (!directionId || !tariffs?.length) return null;

  const doPay = async (tariff, payType) => {
    const price = Number(tariff.price) || 0;
    const discountEligible = isSubscriptionTariff(tariff);
    const amount = computeAmount(price, client, tariff);
    const rawSaleType = Number(client.saleType);
    const saleType = discountEligible && (rawSaleType === 1 || rawSaleType === 2) ? rawSaleType : null;
    const saleAmount = saleType == null ? null : Number(client.saleAmount) || 0;
    let saleAmountByPrice = null;
    if (saleAmount && saleType === 1) {
      saleAmountByPrice = (price / 100) * saleAmount;
    } else if (saleAmount && saleType === 2) {
      saleAmountByPrice = saleAmount;
    }
    const tName = tariffNameById[tariff.tariffId] ?? tariff.tariffId;
    const itemName = `${directionName} (${tName})`;
    try {
      const { data } = await crmApi(branchId).post('/sales', {
        clientId: client.id,
        amount,
        type: payType,
        status: payType === 2 ? 2 : 1,
        items: [
          {
            name: itemName,
            goodsType: 1,
            price,
            count: 1,
            amount,
            saleType,
            saleAmount,
            saleAmountByPrice,
            directionId,
            tariffId: tariff.tariffId,
          },
        ],
      });
      if (data.sale?.paymentUrl) {
        setQrPayment({
          paymentUrl: data.sale.paymentUrl,
          qrCode: data.sale.qrCode,
          amount: data.sale.amount,
          paymentCode: data.sale.paymentCode,
        });
      }
      setOpen(false);
      onPaid?.();
    } catch (e) {
      window.alert(errMsg(e, 'Не удалось провести оплату'));
    }
  };

  return (
    <div className="quick-pay" ref={wrapRef}>
      <UiButton variant="ghost" size="sm" type="button"  className="quick-pay__trigger" onClick={() => setOpen((o) => !o)}>
        ₽
      </UiButton>
      {open && (
        <div className="quick-pay__popover" role="menu">
          {tariffs.map((t) => {
            const nm = tariffNameById[t.tariffId] ?? t.tariffId;
            const amt = computeAmount(t.price, client, t);
            return (
              <div key={t.tariffId} className="quick-pay__row">
                <div className="quick-pay__label">
                  {nm}
                  <span className="quick-pay__price">{amt}₽</span>
                </div>
                <div className="quick-pay__btns">
                  <UiButton variant="ghost" size="sm" type="button"  title="Наличные" onClick={() => doPay(t, 2)}>
                    💵
                  </UiButton>
                  <UiButton variant="ghost" size="sm" type="button"  title="Безнал" onClick={() => doPay(t, 1)}>
                    💳
                  </UiButton>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {qrPayment ? (
        <QrPaymentModal payment={qrPayment} onClose={() => setQrPayment(null)} />
      ) : null}
    </div>
  );
}
